import { WorkerFormService } from 'src/app/data/worker-form.service';
import { Component, Input, OnChanges, OnInit, inject } from '@angular/core';
import { filter, first, takeUntil } from 'rxjs/operators';
import { Messages } from 'src/app/common/enums/messages';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { MatStepper } from '@angular/material/stepper';
import { Subject } from 'rxjs';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { QuestionnaireProcessStep } from 'src/app/common/enums';

@Component({
  selector: 'app-education-history-step',
  templateUrl: './education-history-step.component.html',
  styleUrls: ['./education-history-step.component.scss'],
  standalone: false
})
export class EducationHistoryStepComponent implements OnInit, OnChanges {
  private workerFormService = inject(WorkerFormService);
  private snackbar = inject(SnackBarService);

  @Input() workerId: number;
  @Input() workerFormId: number;
  @Input() stepper: MatStepper;
  @Input() shouldHaveAddedEducation: boolean;
  @Input() isEducationHistoryAlertVisible: boolean;

  selectedStepIndex: number;
  isStudent: boolean;
  isNextButtonDisabled: boolean = false;

  private readonly unsubscribe$ = new Subject<void>();

  constructor() { }

  ngOnInit(): void {
    this.stepper.selectionChange
      .pipe(
        takeUntil(this.unsubscribe$),
        filter((event: StepperSelectionEvent) => event.selectedIndex > event.previouslySelectedIndex),
      )
      .subscribe((x) => {
        if (x.previouslySelectedIndex === QuestionnaireProcessStep.EducationHistory - 1) {
          if (this.isNextButtonDisabled) {
            setTimeout(() => {
              this.stepper.selectedIndex = x.previouslySelectedIndex;
            });

            return;
          }
        }
      });
  }

  ngOnChanges() {
    if (!!this.workerId) {
    }
  }

  private fetchWorkerStudenStatusStatement() {
    if (!this.workerFormId) return;

    this.workerFormService
      .getWorkerStatementByCode(this.workerFormId, "Student")
      .pipe(first())
      .subscribe((statement) => {
        if (statement?.BooleanAnswer) {
          this.snackbar.openSuccessSnackBar(Messages.StudentAlert);
        }
        this.stepper.next();
      });
  }

  nextStep(): void {
    this.fetchWorkerStudenStatusStatement();
  }

  canContinue(isEducationEmpty: boolean) {
    this.isNextButtonDisabled = isEducationEmpty && this.shouldHaveAddedEducation;
  }
}
